export default __webpack_public_path__ + "static/media/rumble-logo.2fb04bf7.png";